angular.module('mercury.modules.error', [
  'mercury.modules.error.permission',
  'mercury.modules.error.service'
]);
